import { Component, OnInit, Inject } from '@angular/core';
import {ReportsService} from './reports.service';
import {AppService} from '../shared/services/app.service';

@Component({
  selector: 'app-hestimate',
  templateUrl: './hestimate.component.html'
})
export class HestimateComponent implements OnInit {

  results:any[];

  constructor(
    private _reportsService: ReportsService,
    private _appService: AppService
  ){

  }

  ngOnInit() {
    this._appService.showLoader();
    this.getReport();
  }

  getReport() {
    this._reportsService.getHestimates().subscribe(
      data => this.results = data.results,
      error => console.log(error),
      () => {
        this._appService.hideLoader();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/hestimate.component.ts